import type { LifecycleStep } from '../ui/LifecycleProgress';

export const workFlowLabels=['Summary','Assessment','Scope','Procurement','Delivery','Inspection','Completion'] as const;

const statusStep:Readonly<Record<string,number>>={Reported:0,Assessment:1,'Scope agreed':2,Procurement:3,'Awaiting approval':3,Instructed:4,'In progress':4,'Awaiting inspection':5,Completed:6,Reopened:1};

export function workStepForStatus(status:string):number|null{return statusStep[status]??null}

export function canViewWorkStep(status:string,requested:number){
 const current=workStepForStatus(status);
 return current!==null&&requested>=0&&requested<=current;
}

export function workLifecycleSteps(status:string,blocked=false):ReadonlyArray<LifecycleStep>|null{
 const current=workStepForStatus(status);
 if(current===null)return null;
 return workFlowLabels.map((label,index)=>({
  id:String(index),label,selectable:index<=current,
  state:index<current?'complete':index>current?'upcoming':blocked?'blocked':'current',
 }));
}

export function workLifecycleUnavailableReason(status:string){
 return status==='Cancelled'
  ?'This work was cancelled. The current record does not identify its last linear stage, so no lifecycle position has been guessed.'
  :`The recorded status “${status}” is not mapped to the approved Work lifecycle, so no lifecycle position has been guessed.`;
}

export function formatWorkEstimatedCost(value:number|null|undefined){
 return value==null?'Not recorded':new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(value);
}

export function previousWorkStep(viewed:number){return Math.max(0,viewed-1)}
